import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import '../css/ProjectFundingAllocation.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ProjectFundingAllocation = ({ triggerAnimation }) => {
  const [chartData, setChartData] = useState({
    labels: ['Marketing', 'Development', 'Liquidity', 'Community Engagement', 'Ecosystem Rewards'],
    datasets: [
      {
        label: 'Allocation (%)',
        data: [0, 0, 0, 0, 0],
        backgroundColor: ['#7f7f7f', '#e0e0e0', '#232323', '#b0b0b0', '#8c8c8c'],
        borderColor: '#444',
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  });

  useEffect(() => {
    if (triggerAnimation) {
      const timeoutId = setTimeout(() => {
        setChartData({
          labels: ['Marketing', 'Development', 'Liquidity', 'Community Engagement', 'Ecosystem Rewards'],
          datasets: [
            {
              label: 'Allocation (%)',
              data: [12.5, 50, 10, 15, 12.5],
              backgroundColor: ['#232323', '#232323', '#232323', '#232323', '#232323'],
              borderColor: '#444',
              borderWidth: 1,
              borderRadius: 5,
            },
          ],
        });
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [triggerAnimation]);

  const getResponsiveFontSize = () => {
    if (window.innerWidth <= 768) {
      return 12; 
    } else {
      return 18; 
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1000,
      easing: 'easeOutQuad',
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#ffffff',
          font: {
            size: getResponsiveFontSize(), 
            weight: 'bold',
          },
          padding: 10,
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: '#ffffff',
          font: {
            size: getResponsiveFontSize(), 
          },
          padding: 10,
        },
        grid: {
          color: '#444',
        },
        beginAtZero: true,
        max: 100,
      },
    },
  };


  return (
    <div className={`project-funding-allocation ${triggerAnimation ? 'visible' : ''}`}>
      <h3>Project Funding Allocation</h3>
      <div className="allocation-wrapper">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ProjectFundingAllocation;
